
import { defineComponent, onBeforeUpdate, onMounted, computed, ref } from 'vue'
import { useStore } from '@/store/index'
import { useRoute } from 'vue-router'
import { axios } from '@/plugins/axios'
import LayoutsAuth from '@/layouts/Auth.vue'
import VideoDetailsBookmarkButton from '@/components/VideoDetailsBookmarkButton.vue'
import VideoDetailsWatchCompletionButton from '@/components/VideoDetailsWatchCompletionButton.vue'
import VideoCategoryListContent from '@/components/VideoCategoryListContent.vue'
import { toArray } from '@/utils/array'
import VideoDetailsTagList from '@/components/VideoDetailsTagList.vue'
import VideoDetailsQuestion from '@/components/VideoDetailsQuestion.vue'
import LayoutsAuthWidth from '@/layouts/AuthWidth.vue'
import { dayjs } from '@/plugins/dayjs'

export default defineComponent({
  components: {
    LayoutsAuth, VideoDetailsBookmarkButton, VideoDetailsWatchCompletionButton, VideoDetailsTagList, VideoDetailsQuestion, VideoCategoryListContent, LayoutsAuthWidth
  },
  setup() {
    const store = useStore()
    const route = useRoute()
    const videoCategories = computed(() => {
      if (store.state.video.videoDetails) {
        return store.getters['video/filterVideoCategoriesById'](store.state.video.videoDetails.id)
      }
      return undefined
    })

    const initialize = () => {
      const getVideo = axios.get(`/video/${route.params.video_id}`)
      const addWatchHistory = axios.post(`/video/watch-history/${route.params.video_id}`)
      Promise.allSettled([
        getVideo,
        addWatchHistory,
        store.dispatch('video/fetchVideoCategories')
      ])
        .then(resolve => {
          const videoDetails = resolve[0].status === 'fulfilled' ? resolve[0].value.data.payload : undefined
          store.commit('video/setVideoDetails', videoDetails)
        })
    }

    onBeforeUpdate(() => {
      initialize()
    })

    onMounted(() => {
      initialize()
    })

    return {
      store,
      toArray,
      videoCategories,
      dayjs,
    }
  },
})
